import { useMutation } from "react-query";

import reservationsService from "api/reservationsService";
import { IRecalculateReservationAmountURLParams } from "types/reservation";

const useRecalculateReservationAmountMutation = ()=> {
  return useMutation(async(params: IRecalculateReservationAmountURLParams) => {
    try {
      const res = await reservationsService.recalculateReservationAmount(params)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useRecalculateReservationAmountMutation